module.exports = __webpack_public_path__ + "img/avatar48-1.5d2afcfe.png";